import { reqGet } from 'HttpRequests'
import { TRequestOptionsCallback } from './ISelect'

function reqGetDelivTypes(callbak: TRequestOptionsCallback) {
  reqGet('api/get_delivery_types/', callbak)
}

function reqGetAvailableCities(callbak: TRequestOptionsCallback) {
  reqGet('api/get_available_cities/', callbak)
}
export { reqGetDelivTypes, reqGetAvailableCities }
